<template>
  <div>
    <div class="package">
      <div class="name center">{{value.package_name}}</div>
      <div class="line"></div>
      <div class="count center">
        <span>{{value.single_num}}道单选题</span>
        <span>{{value.multi_num}}道多选题</span>
        <span>{{value.judge_num}}道判断题</span>
        <!-- <span>{{value.connection_num}}道连线题</span> -->
        <span>{{value.subjective_num}}道简答题</span>
        <span>共计{{value.score}}分</span>
      </div>
      <a class="download" @click="download" v-if="showDownload">
        <i class="ivu-icon ivu-icon-ios-arrow-round-down"></i>下载作业
      </a>
    </div>
    <div class="list">
      <HomeworkPreviewQuestion
        v-for="(ques,index) in list"
        :key="ques.id"
        :ques="ques"
        :readonly="true"
        :hasAnalysis="true"
        :index="index+1"
        class="ques-homework"
      ></HomeworkPreviewQuestion>
    </div>
  </div>
</template>
<script>
import HomeworkPreviewQuestion from "./HomeworkPreviewQuestion";
export default {
  name: "HomeworkPreview",
  components: {
    HomeworkPreviewQuestion
  },
  props: {
    list: {
      type: Array
    },
    value: {
      type: Object
    },
    showDownload: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async download() {
      let data = await this.$http.get(
        "/api/homework/download/" + this.$route.query.id
      );
      window.open(data.url);
    }
  }
};
</script>
<style lang="scss" scoped>
.package {
  background-color: white;
  border: 1px solid rgba(231, 233, 233, 1);
  padding: 35px 32px;
  margin-bottom: 30px;
  position: relative;
  .download {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(140, 140, 140, 1);
    position: absolute;
    top: 40px;
    right: 31px;
    cursor: pointer;
    i {
      margin-right: 6px;
    }
  }
  .name {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-bottom: 33px;
  }
  .line {
    height: 1px;
    border-top: 1px solid rgba(222, 222, 222, 1);
    margin-bottom: 25px;
  }
  .count {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    span {
      margin-right: 28px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
.list {
  background-color: white;
}
</style>
